const state = {
    showLoadingPage: false, // control show top loading bar or not
    showOverlay: false, // control show overlay or not
    snackMessage: { // snack props 
        show: false,
        message: '',
        type: 'success',
        refresh: false,
        redirect: '',
    },
    miniDrawer: false, // control collapse nav menu or not
    isLoading: false, // tells submission/upload is processing or not
    isUploading: false, // tells upload is processing or not
    dataIsUpdated: false, // tells details is edited without saving or not
}

const getters = {
    showLoadingPage: state => state.showLoadingPage,
    snackMessage: state => state.snackMessage,
    showOverlay: state => state.showOverlay,
    isLoading: state => state.isLoading,
    isUploading: state => state.isUploading,
    miniDrawer: state => state.miniDrawer,
    dataIsUpdated: state => state.dataIsUpdated,
}

const actions = {
    toggleLoadingPage({ commit }, data = false) {
        commit('setLoadingPage', data)
    },
    toggleSnack({ commit }, data = null) {
        let obj = {
            show: false,
            message: '',
            type: 'success',
            refresh: false,
            redirect: ''
        };
        if (data === null) {
            commit('toggleSnack', obj)
        } else {
            obj.show = true;
            obj.message = data.message || '';
            obj.type = data.type || 'success';
            obj.refresh = data.refresh || false;
            obj.redirect = data.redirect || '';

            switch (data.message) {
                case 'processing':
                    obj.message = 'message.processing';
                    obj.type = 'error';
                    break;
                case 'required':
                    obj.message = 'message.required';
                    obj.type = 'error';
                    break;
                case 'invValue':
                    obj.message = 'message.invValue';
                    obj.type = 'error';
                    break;
                case 'noPermission':
                    obj.message = 'message.noPermissionMsg';
                    obj.type = 'error';
                    break;
            }
            commit('toggleSnack', obj)
        }
    },
    toggleOverlay({ commit }, data = false) {
        commit('setOverlay', data)
    },
    setDrawer({ commit }, data = false) {
        commit('setDrawer', data)
    },
    setLoading({ commit }, data = false) {
        commit('setLoading', data)
    },
    setUploadLoading({ commit }, data = false) {
        commit('setUploadLoading', data)
    },
    setDataIsUpdated({ commit }, data = false) {
        commit('setDataIsUpdated', data)
    },
}

const mutations = {
    setLoadingPage: function (state, bool) {
        state.showLoadingPage = bool
    },
    toggleSnack: function (state, data) {
        state.snackMessage = data
    },
    setOverlay: function (state, bool) {
        state.showOverlay = bool
    },
    setDrawer: function (state, bool) {
        state.miniDrawer = bool;
    },
    setLoading: function (state, bool) {
        state.isLoading = bool;
    },
    setUploadLoading: function (state, bool) {
        state.isUploading = bool
    },
    setDataIsUpdated: function (state, bool) {
        state.dataIsUpdated = bool
    },
}

export default {
    state,
    getters,
    actions,
    mutations,
}